import React from 'react';
import { CircularProgress } from '@mui/material';
import { CCIframe } from '../Wallet/CC/CCIframe';

export default function CCPayment({ errorToast, account, submitPayment, tokenCreateError, setPaymentMethod }) {

    return <>
        <div style={{ maxHeight: "630px" }}>
            <CCIframe
                fail={errorToast}
                onComplete={submitPayment}
                useAnon={false}
                accountId={account.id}
                saveToWallet={false}
                tokenCreateError={tokenCreateError}
                setPaymentMethod={setPaymentMethod}>
                <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
            </CCIframe>
        </div>
    </>
}